module.exports = __webpack_public_path__ + "staticcomp/img/cover.bd4bd3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/2/cover.jpg
// module id = MLT6
// module chunks = 39